import { render, staticRenderFns } from "./backButton.vue?vue&type=template&id=ea1ef048&scoped=true"
import script from "./backButton.vue?vue&type=script&lang=js"
export * from "./backButton.vue?vue&type=script&lang=js"
import style0 from "./backButton.vue?vue&type=style&index=0&id=ea1ef048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1ef048",
  null
  
)

export default component.exports